import { Card, CardDeck, Image } from "react-bootstrap"
import brainCon from "../images/developpement.png"
import brainAging from "../images/disease.png"
import evolutionSvg from "../images/evolution.png"
import React, { useState } from "react"
import styled from "styled-components"

const styleCardTitle = {
  textAlign: "center",
  color: "#54AE8E",
  paddingTop: "20px",
  fontSize: "20px",
}

const styleCardBody = {
  color: "#B1B4B7",
  textIndent: "20px",
}
const radius = "20px"

const styleCardLearnMore = {
  textAlign: "center",
  color: "floralWhite",
  paddingTop: "20px",
  fontSize: "20px",
}

const styleCardBodyHover = {
  color: "#B1B4B7",
  textIndent: "20px",
  opacity: "60%",
}
const styleCard = {
  backgroundColor: "#242526",
  borderRadius: "0px",
  margin: "5px",
}
const styleCardHover = {
  backgroundColor: "#B1B4B7",
  borderRadius: "0px",
  margin: "5px",
}

const LearnMore = styled.div`
 text-align: center;
 font: bold;
 color: #54AE8E,
`

const leftCardStyle = {
  ...styleCard,
  borderTopLeftRadius: radius,
  borderBottomLeftRadius: radius,
}

const rightCardStyle = {
  ...styleCard,
  borderBottomRightRadius: radius,
  borderTopRightRadius: radius,
}
export default function CardResearch() {
  const [isShown, setIsShown] = useState(false)
  const [isShown2, setIsShown2] = useState(false)
  const [isShown3, setIsShown3] = useState(false)

  return (
    <CardDeck
      style={{
        marginLeft: "10%",
        marginRight: "10%",
        flexDirection: "row",
        justifyContent: "space-evenly",
      }}
    >
      <Card style={leftCardStyle} onClick={() => {
        window.location.href = "organelles"
      }}
            onMouseEnter={() => setIsShown(true)}
            onMouseLeave={() => setIsShown(false)}>
        <br/>
        {isShown === false &&
        <>
          <Image className="cardImage" src={brainCon}/>
          <Card.Title style={styleCardTitle}>Cell biology of the neuron</Card.Title>
          <Card.Body style={styleCardBody}>
            What are the cellular and molecular mechanisms patterning the
            connectivity of cortical circuits during mammalian development?
          </Card.Body>
        </>
        }
        {isShown === true &&
        <div  style={{cursor: "pointer"}}>
          <Image className="cardImage" src={brainCon} style={{cursor: "pointer"}}/>
          <Card.Title style={styleCardLearnMore}>LEARN MORE</Card.Title>
          <Card.Body style={styleCardBodyHover}>
            What are the cellular and molecular mechanisms patterning the
            connectivity of cortical circuits during mammalian development?
          </Card.Body>
        </div>
          }
      </Card>

      <Card style={styleCard}
            onMouseEnter={() => setIsShown2(true)}
            onMouseLeave={() => setIsShown2(false)}
            onClick={() => {
              window.location.href = "evolution"
            }}>
        <br/>
        {isShown2 === false &&
        <>
          <Image className="cardImage" src={evolutionSvg}/>
          <Card.Title style={styleCardTitle}>Evolution</Card.Title>
          <Card.Body style={styleCardBody}>
            What are the genetic mechanisms that led to the evolution of human
            cortical circuits?
          </Card.Body>

        </>}
        {isShown2 === true &&

        <div  style={{cursor: "pointer"}}>
          <Image className="cardImage" src={evolutionSvg} />
          <Card.Title style={styleCardLearnMore}>LEARN MORE</Card.Title>
          <Card.Body style={styleCardBodyHover}>
            What are the genetic mechanisms that led to the evolution of human
            cortical circuits?
          </Card.Body>
        </div>
        }
      </Card>

      <Card style={rightCardStyle}
            onMouseEnter={() => setIsShown3(true)}
            onMouseLeave={() => setIsShown3(false)}
            onClick={() => {
              window.location.href = "aging"
            }}
      >
        <br/>
        {isShown3 === false &&
        <>
          <Image className="cardImage" src={brainAging}  />
          <Card.Title style={styleCardTitle}>Aging</Card.Title>
          <Card.Body style={styleCardBody}>
            What are the signaling mechanisms underlying synaptic loss during
            early stages of Alzheimer’s Disease?
          </Card.Body>
        </>
        }

        {isShown3 === true &&
          <div  style={{cursor: "pointer"}}>
          <Image className="cardImage" src={brainAging}/>
          <Card.Title style={styleCardLearnMore}>LEARN MORE</Card.Title>
          <Card.Body style={styleCardBodyHover}>
            What are the signaling mechanisms underlying synaptic loss during
            early stages of Alzheimer’s Disease?
          </Card.Body>
        </div>
        }
      </Card>
    </CardDeck>
  )
}

//  position: absolute;
//  top: 50%;
//  left: 30%;